export default {
      id: "oc-res-log-manage-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-log-manage",
      toString: function () {
        return this.url;
      }
    }